import { Button, Spinner, Stack, Table } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useContext } from "react";
import { useMediaQuery } from "@mui/material";

import {
  format_currency_2,
  format_currency_4,
  format_percent_2,
  format_percent_3,
  format_percent_4,
  format_percent_5,
} from "../../common/format";

import { OrcamentoVendaContext } from "../../contexts/orcamentovenda-context";

const TotalControl = (props) => {
  const {
    totais,
    atualizartotal,
    onAtualizartotal,
    recalculando,
  } = props;

  const { configs, constantes } = useContext(
    OrcamentoVendaContext
  );

  const isMobile = useMediaQuery("(max-width:768px)");

  const mostrarComissao =
    !configs.DesabilitarCamposConformePerfil;

  function renderInput(
    value,
    format,
    placeholder = "0,00",
    style = {}
  ) {
    return (
      <Form.Control
        disabled
        placeholder={placeholder}
        value={format.format(value ?? 0)}
        style={{
          textAlign: "right",
          padding: "0.2rem 0.45rem",
          minHeight: "34px",
          ...style,
        }}
      />
    );
  }

  const campos = [
    {
      label: constantes.TotalItens,
      value: renderInput(
        totais?.TotalItens,
        format_percent_2
      ),
      fullRow: true,
    },
    {
      label: constantes.PesoLiquidoTotal,
      value: renderInput(
        totais?.PesoLiquidoTotal,
        format_percent_3,
        "0,000"
      ),
    },
    {
      label: constantes.PesoBrutoTotal,
      value: renderInput(
        totais?.PesoBrutoTotal,
        format_percent_3,
        "0,000"
      ),
    },
    {
      label: constantes.Cubagem,
      value: renderInput(
        totais?.Cubagem,
        format_percent_4,
        "0,0000"
      ),
    },
    {
      label: constantes.DescontoAcimaAuto,
      value: renderInput(
        totais?.DescontoAcimaAuto,
        format_percent_4,
        "0,0000"
      ),
    },
    {
      label: constantes.BaseCalculoComissao,
      value: renderInput(
        totais?.BaseCalculoComissao,
        format_currency_2
      ),
      somenteComissao: true,
    },
    {
      label: constantes.TotalPrecoTabela,
      value: renderInput(
        totais?.TotalPrecoTabela,
        format_currency_2
      ),
    },
    {
      label: constantes.PercentualComissao,
      value: renderInput(
        totais?.PercentualComissao,
        format_percent_5,
        "0,00000"
      ),
      somenteComissao: true,
    },
    {
      label: constantes.PrecentualDescAcimaAuto,
      value: renderInput(
        totais?.PercentualDescontoAcima,
        format_percent_4,
        "0,0000"
      ),
    },
    {
      label: constantes.ValorComissao,
      value: renderInput(
        totais?.ValorComissao,
        format_currency_2
      ),
      somenteComissao: true,
    },
    {
      label: `${constantes.TotalFrete} (+)`,
      value: renderInput(
        totais?.TotalFrete,
        format_currency_2
      ),
    },
    {
      label: `${constantes.ValorST} (+)`,
      value: renderInput(
        totais?.ValorSt,
        format_currency_4,
        "0,0000"
      ),
    },
    {
      label: `${constantes.TotalIPI} (+)`,
      value: renderInput(
        totais?.TotalIpi,
        format_currency_2
      ),
    },
    {
      label: `${constantes.FCPST} (+)`,
      value: renderInput(
        totais?.ValorFCPRetSt,
        format_currency_4,
        "0,0000"
      ),
    },
    {
      label: `${constantes.ValorDif} (+)`,
      value: renderInput(
        totais?.ValorDif,
        format_currency_2
      ),
    },
  ];

  const camposFiltrados = campos.filter((campo) => {
    if (
      campo.somenteComissao &&
      !mostrarComissao
    ) {
      return false;
    }

    return true;
  });

  function agruparCampos(lista, tamanho) {
    const grupos = [];

    for (
      let i = 0;
      i < lista.length;
      i += tamanho
    ) {
      grupos.push(lista.slice(i, i + tamanho));
    }

    return grupos;
  }

  const camposNormais = camposFiltrados.filter(
    (campo) => !campo.fullRow
  );

  const grupos = agruparCampos(
    camposNormais,
    isMobile ? 1 : 2
  );

  return (
    <Table
      bordered
    >
      <tbody>
        {camposFiltrados
          .filter((campo) => campo.fullRow)
          .map((campo, index) => (
            <tr key={`full-${index}`}>
              <td
                colSpan={isMobile ? 1 : 3}
              >
                {campo.label}
              </td>

              <td
                style={{
                  verticalAlign: "middle",
                  padding: "0.3rem",
                }}
              >
                {campo.value}
              </td>
            </tr>
          ))}

        {grupos.map((grupo, index) => (
          <tr key={index}>
            {grupo.map((campo, idx) => (
              <>
                <td
                  key={`${index}-${idx}-label`}
                  style={{
                    verticalAlign: "middle",
                    padding: "0.3rem",
                  }}
                >
                  {campo.label}
                </td>

                <td
                  key={`${index}-${idx}-value`}
                  style={{
                    width: isMobile
                      ? "50%"
                      : undefined,
                    padding: "0.3rem",
                  }}
                >
                  {campo.value}
                </td>
              </>
            ))}
          </tr>
        ))}

        <tr>
          <td
            colSpan={isMobile ? 1 : 3}
            style={{
              fontSize: 25,
              fontWeight: "bold",
              verticalAlign: "middle",
              color: atualizartotal ? "gray" : undefined,
              padding: "0.3rem",
            }}
          >
            {constantes.ValorTotal}

            {atualizartotal &&
              " ** Falta atualizar **"}
          </td>

          <td
            style={{
              padding: "0.3rem",
            }}
          >
            {recalculando ? (
              <Stack
                direction="horizontal"
                gap={1}
              >
                <Spinner
                  variant="success"
                  animation="border"
                  role="status"
                />

                Recalculando
              </Stack>
            ) : (
              renderInput(
                totais?.ValorTotal,
                format_currency_2,
                "0,00",
                {
                  fontSize: 25,
                  fontWeight: "bold",
                  color: atualizartotal ? "gray" : undefined,
                }
              )
            )}

            {atualizartotal && (
              <Button
                variant="success"
                style={{
                  width: "100%",
                  marginTop: 4,
                }}
                onClick={onAtualizartotal}
                disabled={recalculando}
              >
                {recalculando ? (
                  <Spinner
                    animation="border"
                    role="status"
                  />
                ) : (
                  "Atualizar Total"
                )}
              </Button>
            )}
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

export default TotalControl;